import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button';
import { rem } from 'polished';
import media from 'utils/media';
import axios from 'axios';

import { FONT_FAMILIES, COLOR, BORDER_RADIUS, FONT_SIZES, SPACE } from 'config';

const BUTTON_WIDTH = 140;

/* todo: clarify necessity of id selector usage */
const Wrapper = styled.div`
  position: relative;
  margin: ${props => (props.home ? rem(SPACE[6]) : 0)} 0 0;
  
  #mc-embedded-subscribe {
    width: 100%;
    margin: ${rem(SPACE[4])} 0 0;
    
    ${media.sm.css`
      position: absolute;
      top: -1px;
      right: 0;
      margin: 0;
      width: ${rem(BUTTON_WIDTH)};
    `}
  }
  
  .response,
  .mce_inline_error {
    margin: 0;  
    color: ${props => (!props.reverted ? COLOR.white : COLOR.base)};
    padding-left: ${rem(SPACE[2])};
    font-size: ${rem(FONT_SIZES[2])};
    font-family: ${FONT_FAMILIES.sans};
  }
  
  #mce-success-response, 
  #mce-error-response, 
  div.mce_inline_error {
    margin-top: ${rem(SPACE[2])};
  }
  
  .response a {
    color: ${props => (!props.reverted ? COLOR.white : COLOR.base)};
    font-size: ${rem(FONT_SIZES[2])};
    font-family: ${FONT_FAMILIES.sans};  
  }
`;

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  border-top: 2px solid white;
  border-right: 2px solid white;
  border-bottom: 2px solid white;
  border-left: 2px solid #101F34;
  background: transparent;
  width: 16px;
  height: 16px;
  border-radius: 50%;
`;

const Input = styled.input`
  display: block;
  width: 100%;
  border: 1px solid ${props => (!props.reverted ? COLOR.white : COLOR.base)};
  background: transparent;
  line-height: 20px;
  box-sizing: border-box;
  text-align: left;
  border-radius: ${BORDER_RADIUS.pill};
  font-family: ${FONT_FAMILIES.sans};
  font-size: ${rem(FONT_SIZES[2])};
  padding: ${rem(SPACE[2])} ${rem(SPACE[4])};
  color: ${props => (!props.reverted ? COLOR.white : COLOR.base)};
  
  ${media.sm.css`
    padding: ${rem(SPACE[3])} ${rem(BUTTON_WIDTH)} ${rem(SPACE[3])} ${rem(SPACE[6])};
  `}
  
  &:focus {
    outline: none;
  }
  
  ::-webkit-input-placeholder {
    color: ${props => (!props.reverted ? COLOR.white : '#616161')};
  }
  ::-moz-placeholder {
    color: ${props => (!props.reverted ? COLOR.white : '#616161')};
  }
  :-ms-input-placeholder {
    color: ${props => (!props.reverted ? COLOR.white : '#616161')};
  }
  :-moz-placeholder {
    color: ${props => (!props.reverted ? COLOR.white : '#515151')};
  }
`;

const Form = styled.form`
  width: 100%;
`;

const Submit = Button.withComponent('button');

class SignUpForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isError: '',
      responseMessage: '',
      email: '',
      loading: false,
    };
  }

  validateEmail = (email) => {
    /* eslint-disable no-useless-escape */
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { email } = this.state;

    if (email === '') {
      this.setState({ responseMessage: 'This field is required' });
      return;
    }

    if (!this.validateEmail(email)) {
      this.setState({ responseMessage: 'Invalid email address' });
      return;
    }

    this.setState({ loading: true, responseMessage: 'Signing up...' });

    axios
      .post(
        'https://cors-anywhere.herokuapp.com/https://api.mailerlite.com/api/v2/groups/42990828/subscribers',
        {
          email,
          fields: {
            source: 'Skycoin.com Newsletter',
          },
        },
        {
          headers: {
            'X-MailerLite-ApiKey': 'a90b5d2da1e6aa5d37abfaee29b57031',
            'Content-Type': 'application/json',
          },
        },
      )
      .then(() => {
        this.setState({
          isError: false,
          responseMessage: 'Thank you for subscribing!',
          email: '',
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          isError: true,
          responseMessage: error.response.data.error.message,
          loading: false,
        });
      });
  };

  handleOnChange = (e) => {
    this.setState({ email: e.target.value });
  }

  render() {
    /* eslint-disable max-len */
    return (
      <Wrapper>
        <Form
          // action="//skycoin.us16.list-manage.com/subscribe/post?u=47a93630ab9172f29aff78b99&amp;id=264afe24a1"
          // method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          ref={(node) => { this.form = node; }}
          target="_blank"
          rel="noopener noreferrer"
          noValidate
          // onSubmit={this.props.onSubmitCallback}
          onSubmit={this.handleSubmit}
        >
          <div className="mc-field-group">
            <FormattedMessage id="newsletter.input">
              {message => (
                <Input
                  placeholder={message}
                  type="email"
                  name="EMAIL"
                  className="required email"
                  id="mce-EMAIL"
                  value={this.state.email}
                  onChange={this.handleOnChange}
                  reverted={this.props.reverted}
                />
              )}
            </FormattedMessage>
          </div>
          <div style={{ height: '24px', display: 'flex', alignItems: 'center', marginTop: '4px' }}>
            {this.state.loading && <Spinner />}
            <p className="response" style={{ color: !this.props.reverted ? COLOR.white : COLOR.base }}>{this.state.responseMessage}</p>
          </div>
          <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
            <input
              type="text"
              name="b_47a93630ab9172f29aff78b99_264afe24a1"
              tabIndex="-1"
              value=""
            />
          </div>

          <Submit color={!this.props.reverted ? 'base' : 'white'} bg={!this.props.reverted ? 'white' : 'base'} big width={'200px'} pill type="submit" name="subscribe" id="mc-embedded-subscribe">
            <FormattedMessage id="newsletter.button" />
          </Submit>
        </Form>
      </Wrapper>
    );
    /* eslint-enable max-len */
  }
}

SignUpForm.propTypes = {
  reverted: PropTypes.bool,
};

SignUpForm.defaultProps = {
  reverted: false,
};

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/components/SignUpForm/SignUpForm.js